import $ from 'jquery'

$(document).on('click change', '[data-action]', function (originalEvent) {
  const $this = $(this)
  const action = $this.data('action')

  // Create new action event including reference to original
  const newEvent = action && $.Event(
    [action, originalEvent.type, 'opp.action'].join('.'), {
      originalEvent
    })

  if (newEvent) {
    // Trigger action event
    $this.trigger(newEvent)
    // Pass prevent default to original event
    if (newEvent.isDefaultPrevented()) {
      originalEvent.preventDefault()
    }
  }
})
